<div class="reassign-staff">
  <div class="content">
    <!-- Selection View -->
    <div *ngIf="!selectedReassignmentType" class="selection-view">
      <h2 class="page-title">Select Reassignment Type</h2>

      <div class="reassignment-options">
        <div
          class="reassignment-option"
          *ngFor="let option of reassignmentOptions; let i = index"
          (click)="selectReassignmentType(option)"
        >
          <div class="option-icon">
            <mat-icon>{{ option.icon }}</mat-icon>
          </div>
          <div class="option-content">
            <h3 class="option-title">{{ option.title }}</h3>
            <p class="option-description">{{ option.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Building Reassignment View -->
    <div *ngIf="showBuildingReassignment" class="building-reassignment-view">
      <div class="back-button" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        <span>Back to Reassignment Types</span>
      </div>

      <div class="building-reassignment-content">
        <!-- Step 1: Select New Building -->
        <div class="step-container">
          <h2 class="step-title">Step 1: Select New Building</h2>
          <div class="dropdown-container">
            <label class="dropdown-label">Select new building:</label>
            <select
              class="building-dropdown"
              [(ngModel)]="selectedNewBuilding"
              (change)="onNewBuildingSelected(selectedNewBuilding)"
            >
              <option value="">Select new building…</option>
              <option *ngFor="let building of buildings" [ngValue]="building">
                {{ building.buildingName }}
              </option>
            </select>
          </div>
        </div>

        <!-- Step 2: Filter Staff by Building -->
        <div class="step-container" *ngIf="selectedNewBuilding">
          <h2 class="step-title">Step 2: Filter Staff by Building</h2>
          <div class="filter-container">
            <label class="filter-label"
              >Choose a building to filter staff:</label
            >
            <select
              class="filter-dropdown"
              [(ngModel)]="selectedFilterBuilding"
              (change)="onFilterBuildingSelected(selectedFilterBuilding)"
            >
              <option value="">Choose a building to filter staff…</option>
              <option *ngFor="let building of buildings" [ngValue]="building">
                {{ building.buildingName }}
              </option>
            </select>
          </div>
        </div>

        <!-- Staff List -->
        <div
          class="step-container"
          *ngIf="selectedFilterBuilding && userList.length > 0"
        >
          <h2 class="step-title">Staff List</h2>
          <div class="staff-list-container">
            <div class="list-header">
              <h3>Available Staff</h3>
              <div class="select-all-container">
                <mat-checkbox
                  [checked]="selectAllUsers"
                  [indeterminate]="
                    selectedUsers.length > 0 &&
                    selectedUsers.length < filteredUserList.length
                  "
                  (change)="toggleSelectAllUsers()"
                  [disabled]="filteredUserList.length === 0"
                >
                  Select All
                </mat-checkbox>
              </div>
            </div>

            <div class="search-container">
              <mat-icon class="search-icon">search</mat-icon>
              <input
                type="text"
                placeholder="Search staff…"
                [(ngModel)]="userSearchText"
                (input)="onUserSearchChange(userSearchText)"
                class="search-input"
              />
            </div>

            <div class="list-content">
              <div *ngFor="let user of filteredUserList" class="list-item">
                <mat-checkbox
                  [checked]="isUserSelected(user)"
                  (change)="toggleUserSelection(user)"
                  [disabled]="!user || !user.id"
                >
                </mat-checkbox>
                <span class="item-text"
                  >{{ user?.firstName }} {{ user?.lastName }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Empty state for no staff in building -->
        <div
          class="step-container empty-state"
          *ngIf="selectedFilterBuilding && userList.length === 0"
        >
          <div class="empty-state-content">
            <mat-icon class="empty-icon">people_outline</mat-icon>
            <h3>No staff are currently assigned to this building.</h3>
          </div>
        </div>

        <!-- Assignment Panel -->
        <div class="step-container" *ngIf="selectedUsers.length > 0">
          <h2 class="step-title">Assign Selected Staff to Building</h2>
          <div class="transfer-container">
            <div class="selected-staff-list">
              <h3>Selected Staff ({{ selectedUsers.length }})</h3>
              <div class="selected-staff-items">
                <div
                  *ngFor="let user of selectedUsers"
                  class="selected-staff-item"
                >
                  <span>{{ user.firstName }} {{ user.lastName }}</span>
                  <button
                    class="remove-btn"
                    (click)="toggleUserSelection(user)"
                    title="Remove from selection"
                  >
                    ×
                  </button>
                </div>
              </div>
            </div>

            <div class="assignment-info">
              <h3>Assignment Details</h3>
              <div class="building-info">
                <strong>New Building:</strong>
                {{ selectedNewBuilding.buildingName }}
              </div>
              <div class="staff-count">
                <strong>Staff Count:</strong> {{ selectedUsers.length }}
              </div>
            </div>
          </div>

          <!-- Assignment Type Selection -->
          <div class="assignment-type-selection">
            <h3>Assignment Type</h3>
            <div class="assignment-options">
              <div
                class="assignment-option"
                [class.selected]="assignmentType === 'move'"
                (click)="assignmentType = 'move'"
              >
                <div class="option-header">
                  <div class="option-radio">
                    <input
                      type="radio"
                      name="assignmentType"
                      value="move"
                      [(ngModel)]="assignmentType"
                      [checked]="assignmentType === 'move'"
                    />
                  </div>
                  <div class="option-content">
                    <div class="option-title">
                      <mat-icon class="option-icon">swap_horiz</mat-icon>
                      <span class="title-text">Move Staff</span>
                    </div>
                    <div class="option-description">
                      Remove from
                      <strong
                        >"{{ selectedFilterBuilding?.buildingName }}"</strong
                      >
                      and assign to
                      <strong>"{{ selectedNewBuilding.buildingName }}"</strong>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="assignment-option"
                [class.selected]="assignmentType === 'add'"
                (click)="assignmentType = 'add'"
              >
                <div class="option-header">
                  <div class="option-radio">
                    <input
                      type="radio"
                      name="assignmentType"
                      value="add"
                      [(ngModel)]="assignmentType"
                      [checked]="assignmentType === 'add'"
                    />
                  </div>
                  <div class="option-content">
                    <div class="option-title">
                      <mat-icon class="option-icon">add_circle</mat-icon>
                      <span class="title-text">Add Staff</span>
                    </div>
                    <div class="option-description">
                      Keep in
                      <strong
                        >"{{ selectedFilterBuilding?.buildingName }}"</strong
                      >
                      and also assign to
                      <strong>"{{ selectedNewBuilding.buildingName }}"</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="action-buttons">
            <button
              class="assign-btn"
              (click)="assignBuildingToUsers()"
              [disabled]="!selectedNewBuilding || selectedUsers.length === 0"
            >
              {{ assignmentType === "move" ? "Move" : "Add" }}
              {{ selectedUsers.length }} Staff Member(s) to
              {{ selectedNewBuilding.buildingName }}
            </button>
          </div>
        </div>

        <!-- Validation message -->
        <div
          class="step-container validation-message"
          *ngIf="selectedUsers.length > 0 && !selectedNewBuilding"
        >
          <div class="validation-content">
            <mat-icon class="validation-icon">warning</mat-icon>
            <span>Select a new building before assigning.</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Primary Manager Reassignment View -->
    <div
      *ngIf="showPrimaryManagerReassignment"
      class="primary-manager-reassignment-view"
    >
      <div class="back-button" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        <span>Back to Reassignment Types</span>
      </div>

      <div class="primary-manager-reassignment-content">
        <!-- Step 1: Select New Manager -->
        <div class="step-container">
          <h2 class="step-title">Step 1: Select New Manager</h2>
          <div class="dropdown-container">
            <label class="dropdown-label">Select new manager:</label>
            <select
              class="manager-dropdown"
              [(ngModel)]="selectedNewManager"
              (change)="onNewManagerSelected(selectedNewManager)"
            >
              <option value="">Select new manager…</option>
              <option *ngFor="let manager of managers" [ngValue]="manager">
                {{ manager.firstName }} {{ manager.lastName }}
              </option>
            </select>
          </div>
        </div>

        <!-- Step 2: Filter Staff by Manager -->
        <div class="step-container" *ngIf="selectedNewManager">
          <h2 class="step-title">Step 2: Filter Staff by Manager</h2>
          <div class="filter-container">
            <label class="filter-label"
              >Choose a manager to filter staff:</label
            >
            <select
              class="filter-dropdown"
              [(ngModel)]="selectedFilterManager"
              (change)="onFilterManagerSelected(selectedFilterManager)"
            >
              <option value="">Choose a manager to filter staff…</option>
              <option *ngFor="let manager of managers" [ngValue]="manager">
                {{ manager.firstName }} {{ manager.lastName }}
              </option>
            </select>
          </div>
        </div>

        <!-- Loading state for staff -->
        <div
          class="step-container loading-state"
          *ngIf="selectedFilterManager && isLoadingStaff"
        >
          <div class="loading-content">
            <app-loading-spinner></app-loading-spinner>
            <p>Loading staff members...</p>
          </div>
        </div>

        <!-- Staff List -->
        <div
          class="step-container"
          *ngIf="
            selectedFilterManager && userList.length > 0 && !isLoadingStaff
          "
        >
          <h2 class="step-title">Staff List</h2>
          <div class="staff-list-container">
            <div class="list-header">
              <h3>Available Staff</h3>
              <div class="select-all-container">
                <mat-checkbox
                  [checked]="selectAllUsers"
                  [indeterminate]="
                    selectedUsers.length > 0 &&
                    selectedUsers.length < filteredUserList.length
                  "
                  (change)="toggleSelectAllUsers()"
                  [disabled]="filteredUserList.length === 0"
                >
                  Select All
                </mat-checkbox>
              </div>
            </div>

            <div class="search-container">
              <mat-icon class="search-icon">search</mat-icon>
              <input
                type="text"
                placeholder="Search staff…"
                [(ngModel)]="userSearchText"
                (input)="onUserSearchChange(userSearchText)"
                class="search-input"
              />
            </div>

            <div class="list-content">
              <div *ngFor="let user of filteredUserList" class="list-item">
                <mat-checkbox
                  [checked]="isUserSelected(user)"
                  (change)="toggleUserSelection(user)"
                  [disabled]="!user || !user.id"
                >
                </mat-checkbox>
                <span class="item-text"
                  >{{ user?.firstName }} {{ user?.lastName }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Empty state for no staff under manager -->
        <div
          class="step-container empty-state"
          *ngIf="
            selectedFilterManager && userList.length === 0 && !isLoadingStaff
          "
        >
          <div class="empty-state-content">
            <mat-icon class="empty-icon">people_outline</mat-icon>
            <h3>No staff are currently assigned to this manager.</h3>
          </div>
        </div>

        <!-- Assignment Panel -->
        <div class="step-container" *ngIf="selectedUsers.length > 0">
          <h2 class="step-title">Assign Selected Staff to Manager</h2>
          <div class="transfer-container">
            <div class="selected-staff-list">
              <h3>Selected Staff ({{ selectedUsers.length }})</h3>
              <div class="selected-staff-items">
                <div
                  *ngFor="let user of selectedUsers"
                  class="selected-staff-item"
                >
                  <span>{{ user.firstName }} {{ user.lastName }}</span>
                  <button
                    class="remove-btn"
                    (click)="toggleUserSelection(user)"
                    title="Remove from selection"
                  >
                    ×
                  </button>
                </div>
              </div>
            </div>

            <div class="assignment-info">
              <h3>Assignment Details</h3>
              <div class="manager-info">
                <strong>New Manager:</strong>
                {{ selectedNewManager.firstName }}
                {{ selectedNewManager.lastName }}
              </div>
              <div class="staff-count">
                <strong>Staff Count:</strong> {{ selectedUsers.length }}
              </div>
            </div>
          </div>

          <!-- Assignment Type Selection -->
          <div class="assignment-type-selection">
            <h3>Assignment Type</h3>
            <div class="assignment-options">
              <div
                class="assignment-option"
                [class.selected]="managerAssignmentType === 'move'"
                (click)="managerAssignmentType = 'move'"
              >
                <div class="option-header">
                  <div class="option-radio">
                    <input
                      type="radio"
                      name="managerAssignmentType"
                      value="move"
                      [(ngModel)]="managerAssignmentType"
                      [checked]="managerAssignmentType === 'move'"
                    />
                  </div>
                  <div class="option-content">
                    <div class="option-title">
                      <mat-icon class="option-icon">swap_horiz</mat-icon>
                      <span class="title-text">Move Staff</span>
                    </div>
                    <div class="option-description">
                      Remove from
                      <strong
                        >"{{ selectedFilterManager?.firstName }}
                        {{ selectedFilterManager?.lastName }}"</strong
                      >
                      and assign to
                      <strong
                        >"{{ selectedNewManager.firstName }}
                        {{ selectedNewManager.lastName }}"</strong
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="assignment-option"
                [class.selected]="managerAssignmentType === 'add'"
                (click)="managerAssignmentType = 'add'"
              >
                <div class="option-header">
                  <div class="option-radio">
                    <input
                      type="radio"
                      name="managerAssignmentType"
                      value="add"
                      [(ngModel)]="managerAssignmentType"
                      [checked]="managerAssignmentType === 'add'"
                    />
                  </div>
                  <div class="option-content">
                    <div class="option-title">
                      <mat-icon class="option-icon">add_circle</mat-icon>
                      <span class="title-text">Add Staff</span>
                    </div>
                    <div class="option-description">
                      Keep with
                      <strong
                        >"{{ selectedFilterManager?.firstName }}
                        {{ selectedFilterManager?.lastName }}"</strong
                      >
                      and also assign to
                      <strong
                        >"{{ selectedNewManager.firstName }}
                        {{ selectedNewManager.lastName }}"</strong
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="action-buttons">
            <button
              class="assign-btn"
              (click)="assignManagerToUsers()"
              [disabled]="
                !selectedNewManager ||
                selectedUsers.length === 0 ||
                isProcessing
              "
            >
              <span *ngIf="!isProcessing">
                {{ managerAssignmentType === "move" ? "Move" : "Add" }}
                {{ selectedUsers.length }} Staff Member(s) to
                {{ selectedNewManager.firstName }}
                {{ selectedNewManager.lastName }}
              </span>
              <span *ngIf="isProcessing">
                <i class="fas fa-spinner fa-spin"></i> Processing...
              </span>
            </button>
          </div>

          <!-- Progress indicator - MOVED TO BOTTOM -->
          <div
            *ngIf="isProcessing"
            class="progress-indicator"
            id="progress-indicator"
          >
            <div class="progress-message">{{ progressMessage }}</div>
            <div class="progress-details">
              <span class="progress-percentage"
                >{{ Math.round(progressPercentage) }}%</span
              >
              <span *ngIf="estimatedTimeRemaining > 0" class="time-remaining">
                Estimated time remaining: {{ estimatedTimeRemaining }}s
              </span>
            </div>
            <div class="progress-bar">
              <div
                class="progress-fill"
                [style.width.%]="progressPercentage"
              ></div>
            </div>
            <div class="progress-warning">
              <mat-icon>warning</mat-icon>
              <span>Please do not navigate away during this operation</span>
            </div>
          </div>
        </div>

        <!-- Validation message -->
        <div
          class="step-container validation-message"
          *ngIf="selectedUsers.length > 0 && !selectedNewManager"
        >
          <div class="validation-content">
            <mat-icon class="validation-icon">warning</mat-icon>
            <span>Select a new manager before assigning.</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Secondary Manager Reassignment View -->
    <div
      *ngIf="showSecondaryManagerReassignment"
      class="primary-manager-reassignment-view"
    >
      <div class="back-button" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        <span>Back to Reassignment Types</span>
      </div>

      <div class="primary-manager-reassignment-content">
        <!-- Step 1: Select New Manager -->
        <div class="step-container">
          <h2 class="step-title">Step 1: Select New Manager</h2>
          <div class="dropdown-container">
            <label class="dropdown-label">Select new secondary manager:</label>
            <select
              class="manager-dropdown"
              [(ngModel)]="selectedNewSecondaryManager"
              (change)="
                onNewSecondaryManagerSelected(selectedNewSecondaryManager)
              "
            >
              <option value="">Select new secondary manager…</option>
              <option
                *ngFor="let manager of secondaryManagers"
                [ngValue]="manager"
              >
                {{ manager.firstName }} {{ manager.lastName }}
              </option>
            </select>
          </div>
        </div>

        <!-- Step 2: Filter Staff by Manager -->
        <div class="step-container" *ngIf="selectedNewSecondaryManager">
          <h2 class="step-title">Step 2: Filter Staff by Manager</h2>
          <div class="filter-container">
            <label class="filter-label"
              >Choose a secondary manager to filter staff:</label
            >
            <select
              class="filter-dropdown"
              [(ngModel)]="selectedFilterSecondaryManager"
              (change)="
                onFilterSecondaryManagerSelected(selectedFilterSecondaryManager)
              "
            >
              <option value="">
                Choose a secondary manager to filter staff…
              </option>
              <option
                *ngFor="let manager of secondaryManagers"
                [ngValue]="manager"
              >
                {{ manager.firstName }} {{ manager.lastName }}
              </option>
            </select>
          </div>
        </div>

        <!-- Loading state for staff -->
        <div
          class="step-container loading-state"
          *ngIf="selectedFilterSecondaryManager && isLoadingStaff"
        >
          <div class="loading-content">
            <app-loading-spinner></app-loading-spinner>
            <p>Loading staff members...</p>
          </div>
        </div>

        <!-- Staff List -->
        <div
          class="step-container"
          *ngIf="
            selectedFilterSecondaryManager &&
            userList.length > 0 &&
            !isLoadingStaff
          "
        >
          <h2 class="step-title">Staff List</h2>
          <div class="staff-list-container">
            <div class="list-header">
              <h3>Available Staff</h3>
              <div class="select-all-container">
                <mat-checkbox
                  [checked]="selectAllUsers"
                  [indeterminate]="
                    selectedUsers.length > 0 &&
                    selectedUsers.length < filteredUserList.length
                  "
                  (change)="toggleSelectAllUsers()"
                  [disabled]="filteredUserList.length === 0"
                >
                  Select All
                </mat-checkbox>
              </div>
            </div>

            <div class="search-container">
              <mat-icon class="search-icon">search</mat-icon>
              <input
                type="text"
                placeholder="Search staff…"
                [(ngModel)]="userSearchText"
                (input)="onUserSearchChange(userSearchText)"
                class="search-input"
              />
            </div>

            <div class="list-content">
              <div *ngFor="let user of filteredUserList" class="list-item">
                <mat-checkbox
                  [checked]="isUserSelected(user)"
                  (change)="toggleUserSelection(user)"
                  [disabled]="!user || !user.id"
                >
                </mat-checkbox>
                <span class="item-text"
                  >{{ user?.firstName }} {{ user?.lastName }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Empty state for no staff under secondary manager -->
        <div
          class="step-container empty-state"
          *ngIf="
            selectedFilterSecondaryManager &&
            userList.length === 0 &&
            !isLoadingStaff
          "
        >
          <div class="empty-state-content">
            <mat-icon class="empty-icon">people_outline</mat-icon>
            <h3>No staff are currently assigned to this secondary manager.</h3>
          </div>
        </div>

        <!-- Assignment Panel -->
        <div class="step-container" *ngIf="selectedUsers.length > 0">
          <h2 class="step-title">Assign Selected Staff to Secondary Manager</h2>
          <div class="transfer-container">
            <div class="selected-staff-list">
              <h3>Selected Staff ({{ selectedUsers.length }})</h3>
              <div class="selected-staff-items">
                <div
                  *ngFor="let user of selectedUsers"
                  class="selected-staff-item"
                >
                  <span>{{ user.firstName }} {{ user.lastName }}</span>
                  <button
                    class="remove-btn"
                    (click)="toggleUserSelection(user)"
                    title="Remove from selection"
                  >
                    ×
                  </button>
                </div>
              </div>
            </div>

            <div class="assignment-info">
              <h3>Assignment Details</h3>
              <div class="manager-info">
                <strong>New Secondary Manager:</strong>
                {{ selectedNewSecondaryManager.firstName }}
                {{ selectedNewSecondaryManager.lastName }}
              </div>
              <div class="staff-count">
                <strong>Staff Count:</strong> {{ selectedUsers.length }}
              </div>
            </div>
          </div>

          <!-- Assignment Type Selection -->
          <div class="assignment-type-selection">
            <h3>Assignment Type</h3>
            <div class="assignment-options">
              <div
                class="assignment-option"
                [class.selected]="managerAssignmentType === 'move'"
                (click)="managerAssignmentType = 'move'"
              >
                <div class="option-header">
                  <div class="option-radio">
                    <input
                      type="radio"
                      name="managerAssignmentType"
                      value="move"
                      [(ngModel)]="managerAssignmentType"
                      [checked]="managerAssignmentType === 'move'"
                    />
                  </div>
                  <div class="option-content">
                    <div class="option-title">
                      <mat-icon class="option-icon">swap_horiz</mat-icon>
                      <span class="title-text">Move Staff</span>
                    </div>
                    <div class="option-description">
                      Remove from
                      <strong
                        >"{{ selectedFilterSecondaryManager?.firstName }}
                        {{ selectedFilterSecondaryManager?.lastName }}"</strong
                      >
                      and assign to
                      <strong
                        >"{{ selectedNewSecondaryManager.firstName }}
                        {{ selectedNewSecondaryManager.lastName }}"</strong
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="assignment-option"
                [class.selected]="managerAssignmentType === 'add'"
                (click)="managerAssignmentType = 'add'"
              >
                <div class="option-header">
                  <div class="option-radio">
                    <input
                      type="radio"
                      name="managerAssignmentType"
                      value="add"
                      [(ngModel)]="managerAssignmentType"
                      [checked]="managerAssignmentType === 'add'"
                    />
                  </div>
                  <div class="option-content">
                    <div class="option-title">
                      <mat-icon class="option-icon">add_circle</mat-icon>
                      <span class="title-text">Add Staff</span>
                    </div>
                    <div class="option-description">
                      Keep with
                      <strong
                        >"{{ selectedFilterSecondaryManager?.firstName }}
                        {{ selectedFilterSecondaryManager?.lastName }}"</strong
                      >
                      and also assign to
                      <strong
                        >"{{ selectedNewSecondaryManager.firstName }}
                        {{ selectedNewSecondaryManager.lastName }}"</strong
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="action-buttons">
            <button
              class="assign-btn"
              (click)="assignSecondaryManagerToUsers()"
              [disabled]="
                !selectedNewSecondaryManager ||
                selectedUsers.length === 0 ||
                isProcessing
              "
            >
              <span *ngIf="!isProcessing">
                {{ managerAssignmentType === "move" ? "Move" : "Add" }}
                {{ selectedUsers.length }} Staff Member(s) to
                {{ selectedNewSecondaryManager.firstName }}
                {{ selectedNewSecondaryManager.lastName }}
              </span>
              <span *ngIf="isProcessing">
                <i class="fas fa-spinner fa-spin"></i> Processing...
              </span>
            </button>
          </div>

          <!-- Progress indicator - MOVED TO BOTTOM -->
          <div
            *ngIf="isProcessing"
            class="progress-indicator"
            id="progress-indicator"
          >
            <div class="progress-message">{{ progressMessage }}</div>
            <div class="progress-details">
              <span class="progress-percentage"
                >{{ Math.round(progressPercentage) }}%</span
              >
              <span *ngIf="estimatedTimeRemaining > 0" class="time-remaining">
                Estimated time remaining: {{ estimatedTimeRemaining }}s
              </span>
            </div>
            <div class="progress-bar">
              <div
                class="progress-fill"
                [style.width.%]="progressPercentage"
              ></div>
            </div>
            <div class="progress-warning">
              <mat-icon>warning</mat-icon>
              <span>Please do not navigate away during this operation</span>
            </div>
          </div>
        </div>

        <!-- Validation message -->
        <div
          class="step-container validation-message"
          *ngIf="selectedUsers.length > 0 && !selectedNewSecondaryManager"
        >
          <div class="validation-content">
            <mat-icon class="validation-icon">warning</mat-icon>
            <span>Select a new secondary manager before assigning.</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Requirement Reassignment View -->
    <div
      *ngIf="showRequirementReassignment"
      class="requirement-reassignment-view"
    >
      <div class="back-button" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        <span>Back to Reassignment Types</span>
      </div>

      <div class="requirement-reassignment-content">
        <!-- Step 1: Select Requirement -->
        <div class="step-container">
          <h2 class="step-title">Step 1: Select Requirement</h2>
          <div class="dropdown-container">
            <label class="dropdown-label">Select requirement to assign:</label>
            <select
              class="requirement-dropdown"
              [(ngModel)]="selectedRequirement"
              (change)="onRequirementSelected(selectedRequirement)"
            >
              <option value="">Select requirement…</option>
              <option
                *ngFor="let requirement of requirements"
                [ngValue]="requirement"
              >
                {{ requirement.requirement }}
              </option>
            </select>
          </div>
        </div>

        <!-- Step 2: Select Staff -->
        <div class="step-container" *ngIf="selectedRequirement">
          <h2 class="step-title">Step 2: Select Staff</h2>
          <div class="staff-list-container" *ngIf="userList.length > 0">
            <div class="list-header">
              <h3>Select Staff Members</h3>
              <div class="select-all-container">
                <mat-checkbox
                  [checked]="selectAllUsers"
                  (change)="toggleSelectAllUsers()"
                >
                  Select All ({{ filteredUserList.length }})
                </mat-checkbox>
              </div>
            </div>

            <div class="search-container">
              <mat-icon class="search-icon">search</mat-icon>
              <input
                type="text"
                placeholder="Search staff by name or email..."
                [(ngModel)]="userSearchText"
                (input)="onUserSearchChange(userSearchText)"
                class="search-input"
              />
            </div>

            <div class="list-content">
              <div *ngFor="let user of filteredUserList" class="list-item">
                <mat-checkbox
                  [checked]="isUserSelected(user)"
                  (change)="toggleUserSelection(user)"
                >
                </mat-checkbox>
                <span class="item-text"
                  >{{ user.firstName }} {{ user.lastName }}</span
                >
              </div>
            </div>
          </div>

          <div class="empty-state" *ngIf="userList.length === 0">
            <div class="empty-state-content">
              <mat-icon class="empty-icon">group</mat-icon>
              <h3>No staff found</h3>
            </div>
          </div>
        </div>

        <!-- Step 3: Review and Assign -->
        <div
          class="step-container"
          *ngIf="selectedUsers.length > 0 && selectedRequirement"
        >
          <h2 class="step-title">Step 3: Review and Assign</h2>

          <div class="transfer-container">
            <div class="selected-staff-list">
              <h3>Selected Staff ({{ selectedUsers.length }})</h3>
              <div class="selected-staff-items">
                <div
                  *ngFor="let user of selectedUsers"
                  class="selected-staff-item"
                >
                  <span>{{ user.firstName }} {{ user.lastName }}</span>
                  <button
                    class="remove-btn"
                    (click)="toggleUserSelection(user)"
                    title="Remove from selection"
                  >
                    ×
                  </button>
                </div>
              </div>
            </div>

            <div class="assignment-info">
              <h3>Assignment Details</h3>
              <div class="requirement-info">
                <strong>Requirement:</strong>
                {{ selectedRequirement.requirement }}
              </div>
              <div class="staff-count">
                <strong>Staff Count:</strong>
                {{ selectedUsers.length }} member(s)
              </div>
            </div>
          </div>

          <div class="action-buttons">
            <button
              class="assign-btn"
              (click)="assignRequirementsToUsers()"
              [disabled]="
                selectedUsers.length === 0 ||
                !selectedRequirement ||
                isProcessing
              "
            >
              <span *ngIf="!isProcessing">
                Assign "{{ selectedRequirement.requirement }}" to
                {{ selectedUsers.length }} Staff Member(s)
              </span>
              <span *ngIf="isProcessing">
                <i class="fas fa-spinner fa-spin"></i> Processing...
              </span>
            </button>
          </div>

          <!-- Progress indicator - MOVED TO BOTTOM -->
          <div
            *ngIf="isProcessing"
            class="progress-indicator"
            id="progress-indicator"
          >
            <div class="progress-message">{{ progressMessage }}</div>
            <div class="progress-details">
              <span class="progress-percentage"
                >{{ Math.round(progressPercentage) }}%</span
              >
              <span *ngIf="estimatedTimeRemaining > 0" class="time-remaining">
                Estimated time remaining: {{ estimatedTimeRemaining }}s
              </span>
            </div>
            <div class="progress-bar">
              <div
                class="progress-fill"
                [style.width.%]="progressPercentage"
              ></div>
            </div>
            <div class="progress-warning">
              <mat-icon>warning</mat-icon>
              <span>Please do not navigate away during this operation</span>
            </div>
          </div>
        </div>

        <!-- Validation message -->
        <div
          class="step-container validation-message"
          *ngIf="selectedUsers.length > 0 && !selectedRequirement"
        >
          <div class="validation-content">
            <mat-icon class="validation-icon">warning</mat-icon>
            <span>Please select a requirement before assigning staff.</span>
          </div>
        </div>
      </div>
    </div>

    <!-- User Roles Reassignment View -->
    <div *ngIf="showUserRolesReassignment" class="user-roles-reassignment-view">
      <div class="back-button" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        <span>Back to Reassignment Types</span>
      </div>

      <div class="user-roles-reassignment-content">
        <!-- Info Panel -->
        <div class="info-panel">
          <div class="info-content">
            <mat-icon class="info-icon">info</mat-icon>
            <div class="info-text">
              <p>
                Users with primary or secondary management assignments must have
                those assignments removed first before changing their role.
              </p>
            </div>
          </div>
        </div>

        <!-- Step 1: Filter Staff by Role -->
        <div class="step-container">
          <h2 class="step-title">Step 1: Filter Staff by Role</h2>
          <div class="dropdown-container">
            <label class="dropdown-label">Choose a role to filter staff:</label>
            <select
              class="role-dropdown"
              [(ngModel)]="selectedFilterRole"
              (change)="onFilterRoleSelected(selectedFilterRole)"
            >
              <option value="">Choose a role to filter staff…</option>
              <option *ngFor="let role of availableRoles" [ngValue]="role">
                {{ role.roleName }}
              </option>
            </select>
          </div>
        </div>

        <!-- Loading state for staff -->
        <div
          class="step-container loading-state"
          *ngIf="selectedFilterRole && isLoadingStaff"
        >
          <div class="loading-content">
            <app-loading-spinner></app-loading-spinner>
            <p>Loading staff members...</p>
          </div>
        </div>

        <!-- Staff List -->
        <div
          class="step-container"
          *ngIf="selectedFilterRole && userList.length > 0 && !isLoadingStaff"
        >
          <h2 class="step-title">Staff List</h2>
          <div class="staff-list-container">
            <div class="list-header">
              <h3>Available Staff</h3>
              <div class="select-all-container">
                <mat-checkbox
                  [checked]="selectAllUsers"
                  [indeterminate]="
                    selectedUsers.length > 0 &&
                    selectedUsers.length < filteredUserList.length
                  "
                  (change)="toggleSelectAllUsers()"
                  [disabled]="filteredUserList.length === 0"
                >
                  Select All
                </mat-checkbox>
              </div>
            </div>

            <div class="search-container">
              <mat-icon class="search-icon">search</mat-icon>
              <input
                type="text"
                placeholder="Search staff…"
                [(ngModel)]="userSearchText"
                (input)="onUserSearchChange(userSearchText)"
                class="search-input"
              />
            </div>

            <div class="list-content">
              <div *ngFor="let user of filteredUserList" class="list-item">
                <mat-checkbox
                  [checked]="isUserSelected(user)"
                  (change)="toggleUserSelection(user)"
                  [disabled]="!user || !user.id"
                >
                </mat-checkbox>
                <span class="item-text"
                  >{{ user?.firstName }} {{ user?.lastName }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Empty state for no staff with role -->
        <div
          class="step-container empty-state"
          *ngIf="selectedFilterRole && userList.length === 0 && !isLoadingStaff"
        >
          <div class="empty-state-content">
            <mat-icon class="empty-icon">people_outline</mat-icon>
            <h3>No staff are currently assigned to this role.</h3>
          </div>
        </div>

        <!-- Step 2: Select New Role -->
        <div class="step-container" *ngIf="selectedUsers.length > 0">
          <h2 class="step-title">Step 2: Select New Role</h2>
          <div class="dropdown-container">
            <label class="dropdown-label">Select new role to assign:</label>
            <select
              class="role-dropdown"
              [(ngModel)]="selectedNewRole"
              (change)="onNewRoleSelected(selectedNewRole)"
            >
              <option value="">Select new role…</option>
              <option *ngFor="let role of availableRoles" [ngValue]="role">
                {{ role.roleName }}
              </option>
            </select>
          </div>
        </div>

        <!-- Assignment Panel -->
        <div
          class="step-container"
          *ngIf="selectedUsers.length > 0 && selectedNewRole"
        >
          <h2 class="step-title">Assign Selected Staff to New Role</h2>
          <div class="transfer-container">
            <div class="selected-staff-list">
              <h3>Selected Staff ({{ selectedUsers.length }})</h3>
              <div class="selected-staff-items">
                <div
                  *ngFor="let user of selectedUsers"
                  class="selected-staff-item"
                >
                  <span>{{ user.firstName }} {{ user.lastName }}</span>
                  <button
                    class="remove-btn"
                    (click)="toggleUserSelection(user)"
                    title="Remove from selection"
                  >
                    ×
                  </button>
                </div>
              </div>
            </div>

            <div class="assignment-info">
              <h3>Assignment Details</h3>
              <div class="role-info">
                <strong>Current Role:</strong>
                {{ selectedFilterRole.roleName }}
              </div>
              <div class="new-role-info">
                <strong>New Role:</strong>
                {{ selectedNewRole.roleName }}
              </div>
              <div class="staff-count">
                <strong>Staff Count:</strong> {{ selectedUsers.length }}
              </div>
            </div>
          </div>

          <div class="action-buttons">
            <button
              class="assign-btn"
              (click)="assignRoleToUsers()"
              [disabled]="
                !selectedNewRole || selectedUsers.length === 0 || isProcessing
              "
            >
              <span *ngIf="!isProcessing">
                Move {{ selectedUsers.length }} Staff Member(s) to
                {{ selectedNewRole.roleName }}
              </span>
              <span *ngIf="isProcessing">
                <i class="fas fa-spinner fa-spin"></i> Processing...
              </span>
            </button>
          </div>

          <!-- Progress indicator -->
          <div
            *ngIf="isProcessing"
            class="progress-indicator"
            id="progress-indicator"
          >
            <div class="progress-message">{{ progressMessage }}</div>
            <div class="progress-details">
              <span class="progress-percentage"
                >{{ Math.round(progressPercentage) }}%</span
              >
              <span *ngIf="estimatedTimeRemaining > 0" class="time-remaining">
                Estimated time remaining: {{ estimatedTimeRemaining }}s
              </span>
            </div>
            <div class="progress-bar">
              <div
                class="progress-fill"
                [style.width.%]="progressPercentage"
              ></div>
            </div>
            <div class="progress-warning">
              <mat-icon>warning</mat-icon>
              <span>Please do not navigate away during this operation</span>
            </div>
          </div>
        </div>

        <!-- Validation message -->
        <div
          class="step-container validation-message"
          *ngIf="selectedUsers.length > 0 && !selectedNewRole"
        >
          <div class="validation-content">
            <mat-icon class="validation-icon">warning</mat-icon>
            <span>Select a new role before assigning.</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Coming Soon View -->
    <div
      *ngIf="
        selectedReassignmentType &&
        !showBuildingReassignment &&
        !showPrimaryManagerReassignment &&
        !showSecondaryManagerReassignment &&
        !showRequirementReassignment &&
        !showUserRolesReassignment
      "
      class="coming-soon-view"
    >
      <div class="back-button" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        <span>Back to Reassignment Types</span>
      </div>

      <div class="coming-soon-content">
        <div class="coming-soon-icon">
          <mat-icon>{{ selectedReassignmentType.icon }}</mat-icon>
        </div>
        <h2 class="coming-soon-title">
          {{ selectedReassignmentType.title }} is coming soon
        </h2>
        <p class="coming-soon-description">
          We're working hard to bring you the
          {{ selectedReassignmentType.title.toLowerCase() }} functionality. This
          feature will be available in a future update.
        </p>
        <div class="coming-soon-actions">
          <button class="back-to-selection-btn" (click)="goBack()">
            Back to Selection
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
